// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/section_release_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { WorkflowSection } from "./workflow_template_model_pb";
import { file_bffuser_v1_workflow_template_model } from "./workflow_template_model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/section_release_service.proto.
 */
export const file_bffuser_v1_section_release_service: GenFile = /*@__PURE__*/
  fileDesc("CihiZmZ1c2VyL3YxL3NlY3Rpb25fcmVsZWFzZV9zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxIhoKGEdldFNlY3Rpb25SZWxlYXNlUmVxdWVzdCJTChlHZXRTZWN0aW9uUmVsZWFzZVJlc3BvbnNlEjYKEXJlbGVhc2VkX3NlY3Rpb25zGAEgAygOMhsuYmZmdXNlci52MS5Xb3JrZmxvd1NlY3Rpb24yewoVU2VjdGlvblJlbGVhc2VTZXJ2aWNlEmIKEUdldFNlY3Rpb25SZWxlYXNlEiQuYmZmdXNlci52MS5HZXRTZWN0aW9uUmVsZWFzZVJlcXVlc3QaJS5iZmZ1c2VyLnYxLkdldFNlY3Rpb25SZWxlYXNlUmVzcG9uc2UiAEJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bffuser_v1_workflow_template_model]);

/**
 * @generated from message bffuser.v1.GetSectionReleaseRequest
 */
export type GetSectionReleaseRequest = Message<"bffuser.v1.GetSectionReleaseRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetSectionReleaseRequest.
 * Use `create(GetSectionReleaseRequestSchema)` to create a new message.
 */
export const GetSectionReleaseRequestSchema: GenMessage<GetSectionReleaseRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_section_release_service, 0);

/**
 * @generated from message bffuser.v1.GetSectionReleaseResponse
 */
export type GetSectionReleaseResponse = Message<"bffuser.v1.GetSectionReleaseResponse"> & {
  /**
   * released_sections are canonical sections in display order and always
   * include WORKFLOW_SECTION_SINGLE_DAY.
   *
   * @generated from field: repeated bffuser.v1.WorkflowSection released_sections = 1;
   */
  releasedSections: WorkflowSection[];
};

/**
 * Describes the message bffuser.v1.GetSectionReleaseResponse.
 * Use `create(GetSectionReleaseResponseSchema)` to create a new message.
 */
export const GetSectionReleaseResponseSchema: GenMessage<GetSectionReleaseResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_section_release_service, 1);

/**
 * SectionReleaseService exposes which 計画断面 a new workflow template or
 * workflow case can be created for right now to authenticated browser
 * sessions.
 *
 * @generated from service bffuser.v1.SectionReleaseService
 */
export const SectionReleaseService: GenService<{
  /**
   * @generated from rpc bffuser.v1.SectionReleaseService.GetSectionRelease
   */
  getSectionRelease: {
    methodKind: "unary";
    input: typeof GetSectionReleaseRequestSchema;
    output: typeof GetSectionReleaseResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_section_release_service, 0);

